import { gql } from '@apollo/client';

export default gql`
    query($offset:Int!, $admin: String){
        ModsLimit(offset: $offset, admin: $admin) {
            IdAnimo
            Animo
        }
    }
`;